module.exports = __webpack_public_path__ + "static/media/PlaynGO.d5734fe0.jpg";